<template>
    <div
      id="overlay"
      class="fixed inset-0 bg-black bg-opacity-30 z-30"
      :class="{ 'hidden': !isBlur }"
    ></div>
    <section class="bg-dark-800 shadow-lg shadow-gold-600/20 dark:bg-dark-900 border-b border-gold-600/20 px-6 py-4 flex justify-between items-center w-full z-40 h-[70px] fixed">
        <div class="flex items-center">
            <div id="open-sidebar" class="flex flex-col w-8 h-5 justify-between cursor-pointer me-5 group" @click="toggleSidebar">
                <span id="hamburger_item" class="metallic-gold rounded-full transition-all duration-200"></span>
                <span id="hamburger_item" class="metallic-gold rounded-full transition-all duration-200"></span>
                <span id="hamburger_item" class="metallic-gold rounded-full transition-all duration-200"></span>
            </div>
            <div>
                <RouterLink to="/dashboard" class="metallic-gold-bg text-dark-800 px-4 py-2 rounded-lg flex items-center font-medium hover:opacity-90 transition-opacity duration-200">
                    <HomeIcon class="h-5 w-5 text-dark-800 me-2"/> Beranda
                </RouterLink>
            </div>
        </div>
        <div class="flex items-center gap-4">
            <!-- Dark Mode Toggle -->
            <button @click="toggleDarkMode" class="p-2 rounded-lg hover:bg-dark-700 dark:hover:bg-dark-800 transition-colors duration-200">
                <MoonIcon v-if="isDarkMode" class="h-6 w-6 metallic-gold-icon"/>
                <SunIcon v-else class="h-6 w-6 metallic-gold-icon"/>
            </button>
            <div class="profile relative">
                <span class="flex items-center">
                    <div id="profile-button" @click="toggleProfileDropdown" class="cursor-pointer">
                        <UserCircleIcon class="h-10 w-10 metallic-gold-icon transition-opacity duration-200 hover:opacity-90"/>
                    </div>
                </span>
                <div v-if="isProfileDropdownOpen" class="absolute right-0 mt-2 w-48 bg-light-50 dark:bg-dark-800 border border-gold-500/20 rounded-lg shadow-lg z-50 animate__animated overflow-hidden" :class="{'animate__zoomIn': isProfileDropdownOpen, 'animate__animated animate__fadeOut': !isProfileDropdownOpen}">
                    <RouterLink id="url-profile" to="/profil" class="px-4 py-3 text-sm flex hover:bg-gold-100/10 text-dark-800 dark:text-light-100 transition-colors duration-200">
                        <UserIcon class="me-2 h-4 w-4"/> Profil
                    </RouterLink>
                    <button id="logout" @click="logout" class="w-full flex text-left px-4 py-3 text-sm hover:bg-gold-100/10 text-dark-800 dark:text-light-100 transition-colors duration-200">
                        <ArrowRightOnRectangleIcon class="h-4 w-4 me-2"/> Logout
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { UserCircleIcon, UserIcon, ArrowRightOnRectangleIcon, HomeIcon, SunIcon, MoonIcon } from '@heroicons/vue/24/solid';
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'TopBar',
    components: {
        UserCircleIcon, UserIcon, ArrowRightOnRectangleIcon, HomeIcon, SunIcon, MoonIcon
    },
    data() {
        return {
            modalAttendance: false,
            isBlur: false,
            isProfileDropdownOpen: false,
        }
    },
    computed: {
        ...mapGetters('darkMode', ['isDarkMode'])
    },
    mounted() {
        this.initDarkMode()
    },
    methods: {
        ...mapActions('darkMode', ['toggleDarkMode', 'initDarkMode']),
        toggleSidebar() {
            this.$parent.$refs.sidebar.toggleSidebar();
            this.$emit('toggleBlur');
        },
        toggleProfileDropdown() {
            this.isProfileDropdownOpen = !this.isProfileDropdownOpen;
            if (this.isProfileDropdownOpen) {
                document.addEventListener('click', this.closeProfileDropdown);
            }
        },
        closeProfileDropdown(event) {
            if (event && this.$refs.profileDropdown && !this.$refs.profileDropdown.contains(event.target)) {
                this.isProfileDropdownOpen = false;
                document.removeEventListener('click', this.closeProfileDropdown);
            }
        },
        logout() {
            localStorage.clear();
            this.$router.push('/');
        }
    }
}
</script>

<style>
#hamburger_item {
    height: 3px;
}
</style>